<div class="widget-container" #dataEditGridDiv>
    <!-- Headings -->
    <main >
        <article #fs fullscreen-able [class.is-active]="isActive" [class.isFulScreen]="isActive" style="background-color: #fff;">
            <div class="mb-1">
                <icon-chart 
                    [headerConfig]="item.config?.widget_header_configuration"
                    [rowDataLength]="this.rowData" 
                    [data]="this.rowData" 
                    [pageKey]="pageKey" 
                    [heading]="this.item.config['report_heading']"
                    [chartName]="'GridList'" 
                    [expand]="fs" 
                    [fullscreen]="isFullscreen"
                    [item]="item"
                    (screenChanges)="screenChanges($event)"
                    (exportXls)="exportXls($event)"
                ></icon-chart>

            </div>

            <div *ngIf="loader" style="width: 100%; height: 200px;">
                <loading></loading>
            </div>

            <div style="height: 200px; width: auto; " *ngIf="!loader && rowData.length==0">
                <span class="bg-text"> {{ error_name ? error_name : 'There is no data for this time period' }} </span>
            </div>

            <ag-grid-angular
                style="width: 100%; height: 100%;"
                class="ag-theme-alpine editDataGrid"
                [style.display]="(rowData.length==0 || error_name) ? 'none' : 'block'"
                [class.fullScreenEdits]="isFullscreen"
                [masterDetail]="true"
                [detailCellRenderer]="detailCellRenderer"
                [getRowHeight]="getRowHeight"
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                [rowData]="rowData"
                [class]="themeClass"
                (gridReady)="onGridReady($event)"
                [suppressDragLeaveHidesColumns]="true"
                [rowHeight]="50"
                [suppressRowTransform]="true" 
                [pagination]="true"
                [paginationPageSize]="10"
                (cellEditingStarted)="onCellEditingStarted($event)"
                (cellEditingStopped)="onCellEditingStopped($event)"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                >
            </ag-grid-angular>
        </article>
    </main>
</div>